/*
[GNU Affero General Public License (AGPL)](https://www.gnu.org/licenses/agpl-3.0.html)

VeloceSupabase - A library for working with supabase made in Angular v17+ made with care by Colibryx Srl in Italy.
Copyright (C) 2025 Colibryx S.r.l.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

This license applies to any accompanying files located directly in the same directory.
*/

import { Injectable, OnDestroy, inject } from "@angular/core";
import { CbRoutesUtils } from "@app/@classes/routes/cb-routes-utils";
import { Subject, map, takeUntil } from "rxjs";
import { AuthService } from "./auth.service";
import { LoggerService } from "./logger.service";
import { Router } from "@angular/router";
import { ConfirmationService } from "@app/widgets/base/confirmation/confirmation-manager.service";

@Injectable({
	providedIn: "root",
})
export class LogoutService {
	protected readonly router: Router = inject(Router);
	protected readonly authService = inject(AuthService);
	protected readonly loggerService = inject(LoggerService);

	public confirmationService: ConfirmationService = inject(ConfirmationService);

	logout() {
		this.confirmationService
			.show({
				title: "COMMON.LOGOUT",
				message: "COMMON.LOGOUT_CONFIRMATION",
				dangerous: true,
				confirmText: "COMMON.LOGOUT",
				icon: "cb cb-base-outline-logout",
			})
			.pipe(
				map(async (result: boolean) => {
					if (result) {
						this.authService.signOut().subscribe(() => {
							const url = CbRoutesUtils.paths.auth.login.path;
							this.router.navigate([url]);
						});
					}
				}),
			)
			.subscribe();
	}
}
